'use client'

import React, { useState } from 'react'

import { ChevronDown } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger
} from '@/components/ui/drawer'

import { cn } from '@/utils'

interface MobileToolbarGroupProps {
  children: React.ReactNode
  className?: string
  label: string
}

export const MobileToolbarGroup = ({
  children,
  className,
  label
}: MobileToolbarGroupProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const closeDrawer = () => setIsOpen(false)

  return (
    <Drawer onOpenChange={setIsOpen} open={isOpen}>
      <DrawerTrigger asChild>
        <Button
          className={cn('h-8 w-max gap-1 px-3 font-normal', className)}
          size="sm"
          type="button"
          variant="ghost"
        >
          {label}
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle className="text-start">{label}</DrawerTitle>
        </DrawerHeader>
        <div className="flex flex-col p-4">
          {React.Children.map(children, (child) =>
            React.isValidElement(child)
              ? React.cloneElement(child, { closeDrawer } as {
                  closeDrawer: () => void
                })
              : child
          )}
        </div>
      </DrawerContent>
    </Drawer>
  )
}

export const MobileToolbarItem = ({
  active,
  children,
  closeDrawer,
  onClick,
  ...props
}: {
  active?: boolean
  closeDrawer?: () => void
} & React.ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button
    className={cn(
      'hover:bg-accent flex w-full items-center rounded-md px-4 py-2 text-sm transition-colors',
      active && 'bg-accent'
    )}
    onClick={(e) => {
      onClick?.(e)
      setTimeout(() => {
        closeDrawer?.()
      }, 100)
    }}
    {...props}
  >
    {children}
  </button>
)
